/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { TextField, InputAdornment, CircularProgress } from '@material-ui/core';
import classnames from 'classnames';
import { MainLayout } from '@/components/layout';
import { Backdrop } from '@/components/uikit';
import { PromoList } from '@/types';
import coupon from '@/assets/images/coupon.png';
import discount from '@/assets/images/discount.png';
import arrowLeft from '@/assets/images/arrow_left.png';
import clearText from '@/assets/images/clear_text.png';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { formatTime } from '@/utils/helper';
import { useTranslate } from '@/locale';

type PromoViewProps = {
  promoInput: string;
  handlePromoInput: (arg0: string) => void;
  promoLoading: boolean;
  promoResult: Array<PromoList>;
  location: { state: { subscriptionId: string; promoCode: string } };
  alreadyPickPromo: boolean;
  inputSameAsPickedPromo: boolean;
  userTypeButNoPromo: boolean;
  onSelectPromo: (promoList: PromoList) => void;
  setPromoInput: (arg0: string) => void;
  loading: boolean;
};

const PromoView = (props: PromoViewProps) => {
  const { translate, currentLanguage } = useTranslate();
  const {
    handlePromoInput,
    promoLoading,
    promoResult,
    location,
    promoInput,
    alreadyPickPromo,
    inputSameAsPickedPromo,
    userTypeButNoPromo,
    onSelectPromo,
    setPromoInput,
    loading,
  } = props;

  const history = useHistory();
  const { subscriptionId } = location.state;
  const { search } = useLocation();

  return (
    <MainLayout style={{ padding: '0px 16px' }}>
      <Backdrop open={loading} />
      <div className="promo-top-bar">
        <div className="row">
          <div
            className="btn-promo-header"
            onClick={() =>
              history.replace(`/patient/order/${subscriptionId}${search}`, {
                isChangeWalletState: false,
                origin: 'back-promo',
              })
            }
          >
            <img width="12px" src={arrowLeft} alt="arrow_left" />
          </div>
          <div style={{ width: '100%' }}>
            <p style={{ textAlign: 'center' }} className="title medium-14">
              {translate('usePromoCode')}
            </p>
          </div>
        </div>
        <TextField
          className="form-search-promo"
          value={promoInput}
          onChange={e => handlePromoInput(e.target.value)}
          placeholder={translate('enterPromoCodeHere')}
          InputProps={{
            endAdornment: promoLoading ? (
              <InputAdornment position="end">
                <CircularProgress size={12} />
              </InputAdornment>
            ) : (
              promoInput.length > 0 && (
                <InputAdornment
                  onClick={() => setPromoInput('')}
                  position="end"
                >
                  <img
                    style={{ position: 'absolute', right: -17 }}
                    width="64px"
                    src={clearText}
                    alt="clear_text"
                  />
                </InputAdornment>
              )
            ),
          }}
        />
      </div>
      {userTypeButNoPromo && (
        <div className="promo-result">
          <div
            className={classnames('container-center-column', 'promo-container')}
          >
            <p className={classnames('no-margin', 'no-promo-text ')}>
              {translate('sorryPromoCode')}
            </p>
            <p className="no-margin" style={{ fontSize: '14px' }}>
              {translate('failedReasonPromoCode')}
            </p>
          </div>
        </div>
      )}
      {promoResult.length === 0 && promoInput.length < 1 ? (
        <div className="promo-result">
          <div
            className={classnames('container-center-column', 'promo-container')}
          >
            <img width="64px" src={coupon} alt="coupon" />
            <p className={classnames('no-margin', 'no-promo-text')}>
              {translate('noPromoCode')}
            </p>
            <p className={classnames('no-margin', 'no-promo-desc')}>
              {translate('noPromoCodeInfo')}
            </p>
          </div>
        </div>
      ) : (
        <div className="promo-result">
          {promoResult.map(each => (
            <div
              className={classnames('customized-card', 'promo-customized-card')}
              key={each.promo_code}
            >
              <div className={classnames('promo-result-discount', 'row')}>
                <div className="img-discount">
                  <img width="32px" src={discount} alt="discount" />
                </div>
                <div
                  style={{ justifyContent: 'center', width: '65%' }}
                  className="column"
                >
                  <p className="promo-name bold-14 no-margin">{each.name}</p>
                  <p className={classnames('no-margin', 'text-valid')}>
                    {`${translate('validUntilPromoCode')} ${formatTime(
                      each.end_date,
                      undefined,
                      currentLanguage
                    )}`}
                  </p>
                </div>
                <div className="btn-promo">
                  <div
                    className="link-promo"
                    onClick={() => onSelectPromo(each)}
                  >
                    <p
                      className={classnames(
                        'no-margin',
                        alreadyPickPromo && inputSameAsPickedPromo
                          ? 'already-promo'
                          : ''
                      )}
                    >
                      {alreadyPickPromo && inputSameAsPickedPromo
                        ? translate('promoRemove')
                        : translate('promoAdd')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </MainLayout>
  );
};

export default PromoView;
